import type { FC } from "react";
import {
	type IncomeSheetFormModel,
	type IncomeSheetValues,
	useIncomeSheetForm,
} from "web_myplann/Finances/Forms/useIncomeSheetForm";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { FormAmountStepperField } from "web_myplann/Shared/Components/FormAmountStepperField";
import { FormSheet } from "web_myplann/Shared/Components/FormSheet";
import { FormTextField } from "web_myplann/Shared/Components/FormTextField";

const R = Resources.Finances.IncomeSheet;

type Props = {
	open: boolean;
	isEditing: boolean;
	initialValues?: IncomeSheetValues;
	onClose: () => void;
	onSubmit: (values: IncomeSheetFormModel) => void;
};

export const IncomeFormSheet: FC<Props> = ({
	open,
	isEditing,
	initialValues,
	onClose,
	onSubmit,
}) => {
	const { t } = useResource();
	const {
		control,
		handleSubmit,
		formState: { isValid },
	} = useIncomeSheetForm({ open, initialValues });

	return (
		<FormSheet
			open={open}
			title={isEditing ? t(R.editTitle) : t(R.addTitle)}
			submitLabel={isEditing ? t(Resources.Common.save) : t(R.add)}
			submitDisabled={!isValid}
			onClose={onClose}
			onSubmit={handleSubmit(onSubmit)}
		>
			<FormTextField
				control={control}
				name="name"
				label={t(R.name)}
				placeholder={t(R.namePlaceholder)}
			/>
			<FormAmountStepperField
				control={control}
				name="amount"
				label={t(R.amount)}
			/>
		</FormSheet>
	);
};
